import * as fbq from '@utils/analytics/fpixel'

export function trackTradeProgram() {
  window.dataLayer?.push({
    event: 'trade applied',
  })

  fbq.trackEvent('TradeSignUp')
}
